<template>
  <el-table :data="rateDataTable" stripe style="width: 100%" ref="rateDataTable" border
            v-loading="listLoading">
    <af-table-column prop="id" :label="$t('fei-shuai-mo-xing-id')"></af-table-column>
    <af-table-column prop="ruleName" :label="$t('fei-shuai-ming-cheng')"></af-table-column>
    <af-table-column prop="operatorName" :label="$t('suo-shu-yun-ying-shang-0')"></af-table-column>
    <af-table-column :label="$t('siteMonitor.ElectricityBill')">
      <template  slot-scope="scope">
        <div v-if="scope.row.typeCode === 'standard' && scope.row.pileType == 'Q' ">
          <span style="color: #2fff00;" class="span_one">{{ $t('key') }}</span><span
          v-html="$t('chang-gui-dian-fei')+' : ' + scope.row.standardElectricityFees + $t('yuan-kw')"></span>
        </div>
        <div v-else-if="scope.row.typeCode === 'times'">
          <span style="color: #ff4d4d;" class="span_one">{{ $t('key') }}</span><span
          v-html=" (scope.row.pileType == 'Q'?$t('jian-dian-fei')+' : ':$t('di-yi-jie-duan-gong-lv')) + scope.row.topElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
          <span style="color: #ffbc2e " class="span_one">{{ $t('key') }}</span><span
          v-html=" (scope.row.pileType == 'Q'?$t('feng-dian-fei')+' : ':$t('di-er-jie-duan-gong-lv')) + scope.row.summitElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
          <span style="color: #43c26e" class="span_one">{{ $t('key') }}</span><span
          v-html=" (scope.row.pileType == 'Q'?$t('ping-dian-fei')+' : ':$t('di-san-jie-duan-gong-lv')) + scope.row.flatElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
          <span style="color:#409EFF" class="span_one">{{ $t('key') }}</span><span
          v-html=" (scope.row.pileType == 'Q'?$t('gu-dian-fei')+' : ':$t('wang-hou-jie-duan-gong-lv')) + scope.row.valleyElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
        </div>
      </template>
    </af-table-column>
    <af-table-column prop="serviceFees" :label="$t('siteMonitor.serviceCharge2')">
      <template slot-scope="scope">
        <div v-if="scope.row.typeCode === 'standard'">
          <span style="color: #2fff00;" class="span_one">{{ $t('key') }}</span><span
          v-html="$t('chang-gui-fu-wu-fei')+' : ' + scope.row.standardServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span>
        </div>
        <div v-else-if="scope.row.typeCode === 'times'">
          <span style="color: #ff4d4d;" class="span_one">{{ $t('key') }}</span><span
          v-html="(scope.row.pileType == 'Q'?$t('jian-fu-wu-fei')+' : ':$t('di-yi-jie-duan-fu-fu-fei')) + scope.row.topServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
          <span style="color:  #ffbc2e" class="span_one">{{ $t('key') }}</span><span
          v-html="(scope.row.pileType == 'Q'?$t('feng-fu-wu-fei')+' : ':$t('di-er-jie-duan-fu-fu-fei')) + scope.row.summitServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
          <span style="color: #43c26e" class="span_one">{{ $t('key') }}</span><span
          v-html="(scope.row.pileType == 'Q'?$t('ping-fu-wu-fei')+' : ':$t('di-san-jie-duan-fu-fu-fei')) + scope.row.flatServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
          <span style="color: #409EFF" class="span_one">{{ $t('key') }}</span><span
          v-html="(scope.row.pileType == 'Q'?$t('gu-fu-wu-fei')+' : ':$t('wang-hou-jie-duan-fu-fu-fei')) + scope.row.valleyServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
        </div>
      </template>
    </af-table-column>
    <af-table-column prop="discountRate" :label="$t('zhe-kou-shuai')"></af-table-column>
    <af-table-column prop="electricLossRate" :label="$t('dian-sun-bi-shuai')"></af-table-column>
    <af-table-column :label="$t('deviceControl.operation')" width="160px">
      <template slot-scope="scope">
        <!--                    <el-button size="mini" plain @click="rateDetail(scope.$index, scope.row)">详情</el-button>-->
        <el-button size="mini" @click="rateEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:rate:editRate'])">{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" type="danger" @click="rateDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:rate:deleteRate'])">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      rateDataTable:{},
      listLoading:false,
    },
    methods:{
      rateEdit(index,row){
        this.$emit("rateEdit",index,row)
      },
      rateDelete(index,row){
        this.$emit("rateDelete",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/list.vue